<template>
  <div class="articles">
    <articles-list
      v-if="!openedArticle"
      :articles="articles"
      @open="open"
      @buy="buy"
    />
    <article-content
      v-else
      :article="openedArticle"
      @closeArticle="close"
      @buy="buy"
    />
  </div>
</template>

<script>
import { loadStripe } from '@stripe/stripe-js'
import { i18n } from '@/locales'
import ArticlesList from '@/components/Articles/List'
import Article from '@/components/Articles/Article'

const stripePromise = loadStripe(process.env.VUE_APP_STRIPE_PUBLIC_KEY)

export default {
  data() {
    return {
      articles: [],
      openedArticle: false,
    }
  },
  mounted() {
    if (this.$route.params.article) this.loadArticle(this.$route.params.article)
    else {
      this.openedArticle = false
      this.loadArticles()
    }
  },
  computed: {
    lang() {
      return i18n.locale
    },
  },
  watch: {
    $route() {
      if (this.$route.params.article)
        this.loadArticle(this.$route.params.article)
      else {
        this.openedArticle = false
        this.loadArticles()
      }
    },
    lang() {
      if (this.openedArticle) this.loadArticle(this.openedArticle.slug)
      this.loadArticles()
    },
  },
  methods: {
    buy(article) {
      const followPayment = async (session) => {
        const stripe = await stripePromise
        const result = await stripe.redirectToCheckout({
          sessionId: session.id,
        })
        if (result.error) {
          this.$store.dispatch('layout/showMessage', {
            title: 'Error while redirectToCheckout',
            message: 'result.error',
          })
        }
      }
      if (this.$store.getters['user/isLoggedIn']) {
        this.$store
          .dispatch('request/authorized/createPaymentArticle', {
            id: article.id,
          })
          .then(followPayment)
      } else {
        this.$router.push({
          path: '/auth/login',
          params: {
            next: `/articles?buy=${article.id}`,
          },
        })
        // login, then buy
      }
    },
    open(article) {
      this.$router.push({
        path: `${this.$route.path}/${article.slug}`,
      })
      window.scrollTo(0, 0)
    },
    close() {
      this.$router.push({
        path: '/articles',
      })
    },
    loadArticle(article) {
      this.$store
        .dispatch('request/authorized/getArticle', {
          slug: article,
          lang: i18n.locale,
        })
        .then((a) => (this.openedArticle = a))
        .catch(() => {
          this.close()
        })
    },
    loadArticles() {
      this.$store
        .dispatch('request/authorized/getArticles', {
          lang: i18n.locale,
        })
        .then((a) => (this.articles = a))
    },
  },
  components: {
    'articles-list': ArticlesList,
    'article-content': Article,
  },
}
</script>

<style lang="scss">
.articles {
  position: relative;
  padding-bottom: 40px;
}
</style>
